/*
 * Copyright (c) 2024 MTa Learning. All Rights Reserved.
 *
 * MTa Learning proprietary information: the enclosed materials contain proprietary information of MTa Learning and
 * shall not be disclosed in whole or in any part to any third party or used by any person for any purpose, without
 * written consent of MTa Learning. Duplication of any portion of these materials shall include this notice.
 */
'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:mta-learning":true});}catch(e){}}();

import { useSetAtom } from 'jotai'
import { useHydrateAtoms } from 'jotai/utils'
import React, { useEffect } from 'react'
import { DesktopHeader } from '@/components/e-commerce/header/DesktopHeader'
import { HeaderNavigationBarItem } from '@/components/e-commerce/header/links'
import { MobileHeader } from '@/components/e-commerce/header/MobileHeader'
import { navigationItemsAtom } from '@/store/navigation-items'

/** A description of the available properties for this component. */
type HeaderProps = {
  navigationItems: Array<HeaderNavigationBarItem>
}

/**
 * The main header component for the e-commerce website.
 * It renders both the desktop and mobile versions; a media query determines which one is visible. Both must be present
 * in the server HTML so hydration produces the same tree regardless of the client's viewport width.
 */
const Header: React.FC<HeaderProps> = ({ navigationItems }) => {
  useHydrateAtoms([[navigationItemsAtom, navigationItems]])
  const setNavigationItems = useSetAtom(navigationItemsAtom)

  /**
   * Update the navigation atom when the story changes (as a result of client side navigation or other changes).
   */
  useEffect(() => {
    setNavigationItems(navigationItems)
  }, [navigationItems, setNavigationItems])

  return (
    <>
      <MobileHeader className={'hidden max-[800px]:flex'} />
      <DesktopHeader className={'max-[800px]:hidden'} />
    </>
  )
}

export { Header }
